export default (data, namespace) =>
  namespace.split('.').reduce((acc, key) => acc && acc[key], data)



// WEBPACK FOOTER //
// ./src/utils/findValue.js